var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollarBlueCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_2736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67773 1.01428V15.6809M12.0111 3.68095H7.01107C6.39223 3.68095 5.79874 3.92678 5.36115 4.36437C4.92357 4.80195 4.67773 5.39544 4.67773 6.01428C4.67773 6.63312 4.92357 7.22661 5.36115 7.6642C5.79874 8.10178 6.39223 8.34762 7.01107 8.34762H10.3444C10.9632 8.34762 11.5567 8.59345 11.9943 9.03103C12.4319 9.46862 12.6777 10.0621 12.6777 10.6809C12.6777 11.2998 12.4319 11.8933 11.9943 12.3309C11.5567 12.7685 10.9632 13.0143 10.3444 13.0143H4.67773",
    stroke: "#249CFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_2736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.677734 0.347656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollarBlueCard);
export default __webpack_public_path__ + "static/media/icon-dollar_blue_card.082c8de2e9f6856e7688f3d46cc8a4ec.svg";
export { ForwardRef as ReactComponent };